// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_np-0";